export default function UsersRollIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M7.75 13.7202C9.40685 13.7202 10.75 12.3771 10.75 10.7202C10.75 9.06336 9.40685 7.72021 7.75 7.72021C6.09315 7.72021 4.75 9.06336 4.75 10.7202C4.75 12.3771 6.09315 13.7202 7.75 13.7202ZM7.75 13.7202C6.75636 13.7202 5.78309 14.0021 4.94324 14.5331C4.10338 15.0641 3.43138 15.8225 3.00528 16.7201L1.75 16.7202C1.65151 16.7202 1.55399 16.7008 1.46299 16.6632C1.372 16.6255 1.28932 16.5702 1.21967 16.5006C1.15003 16.431 1.09478 16.3483 1.05709 16.2573C1.0194 16.1663 1 16.0688 1 15.9703V2.47021C1 2.2713 1.07902 2.08054 1.21967 1.93988C1.36032 1.79923 1.55109 1.72021 1.75 1.72021H18.25C18.4489 1.72021 18.6397 1.79923 18.7803 1.93988C18.921 2.08054 19 2.2713 19 2.47021V15.9702C19 16.0687 18.9806 16.1662 18.9429 16.2572C18.9052 16.3482 18.85 16.4309 18.7803 16.5005C18.7107 16.5702 18.628 16.6254 18.537 16.6631C18.446 16.7008 18.3485 16.7202 18.25 16.7202L12.4947 16.7201C12.0686 15.8225 11.3966 15.0641 10.5568 14.5331C9.71691 14.0021 8.74364 13.7202 7.75 13.7202ZM14.5 13.7202H16V4.72021H4V6.22021"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
